import React from "react";
import { Button } from "semantic-ui-react";

export default function Cancel(props) {
  return (
    <>
      <Button
        content={props.content ? props.content : "Cancel"}
        onClick={props.onClick}
        className={props.className}
        disabled={props.disabled ? props.disabled : false}
      />
    </>
  );
}
